import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDeleteSitesParams {
  ids: string[]; // Not urlNames
}

export interface IDeleteSitesResult extends IResult {
  // If no action id is returned, then the job was not started
  actionId?: string;
}

export class DeleteSitesRequest extends Request<IDeleteSitesParams, IDeleteSitesResult> {
  constructor(params: IDeleteSitesParams) {
    super('deleteSites', params);
  }
}
